import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import productsData from '../data/products';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const Products = () => {
  const query = useQuery();
  const initialCategory = query.get('categorie') || 'Tous';
  const [category, setCategory] = useState(initialCategory);
  const [search, setSearch] = useState('');

  const categories = ['Tous', ...Array.from(new Set(productsData.map(p => p.category)))];

  const filtered = productsData.filter(p => {
    const okCat = category === 'Tous' || p.category === category;
    const okSearch = [p.name, p.short, p.description].join(' ').toLowerCase().includes(search.toLowerCase());
    return okCat && okSearch;
  });

  const [selected, setSelected] = useState(null);

  return (
    <section className="section">
      <h2>Produits</h2>
      <div className="card" style={{display:'grid', gap:12}}>
        <div className="grid" style={{gridTemplateColumns:'1fr 1fr'}}>
          <select className="select" value={category} onChange={e => setCategory(e.target.value)}>
            {categories.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
          <input className="input" placeholder="Rechercher…" value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <div className="grid products-grid">
          {filtered.map(p => <ProductCard key={p.id} product={p} onSelect={setSelected} />)}
        </div>
        {selected && (
          <div className="card" style={{borderColor:'#a7f3d0', background:'#ecfdf5'}}>
            <strong>Demande de devis pour : {selected.name}</strong>
            <p style={{fontSize:14}}>{selected.short}</p>
            <a className="btn" href={`mailto:contact@rokatc.com?subject=Demande de devis — ${encodeURIComponent(selected.name)}&body=Bonjour,%0D%0AJe souhaite un devis pour ${encodeURIComponent(selected.name)} (MOQ: ${selected.moq}).%0D%0AQuantité souhaitée : ...%0D%0ASpécifications : ...%0D%0ASociété : ...%0D%0ACoordonnées : ...`}>Envoyer un email</a>
          </div>
        )}
      </div>
    </section>
  );
};

export default Products;
